import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useMemo } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { StoreProvider } from "../../store/StoreContext";
import { WorkspaceLoader } from "./WorkspaceLoader";
import { WidgetShell } from "./WidgetShell";
import { createAppointmentTheme } from "../appointment/muiTheme";
import { useTheme as useMedosTheme } from "../../react/ThemeProvider";
import { DEFAULT_WIDGET_LAYOUT, } from "../../utils/widgetLayout";
export function UnifiedBookingWidget({ onError, onSuccess, maxWidth, maxHeight, height, calendarOnly = false, compact = false, layout = DEFAULT_WIDGET_LAYOUT, verifiedPhone, otpChannels, }) {
    const queryClientRef = useRef(null);
    if (!queryClientRef.current) {
        queryClientRef.current = new QueryClient({
            defaultOptions: {
                queries: {
                    retry: 1,
                    refetchOnWindowFocus: false,
                    staleTime: 5 * 60 * 1000,
                },
            },
        });
    }
    const medosTheme = useMedosTheme();
    const muiTheme = useMemo(() => createAppointmentTheme(medosTheme), [medosTheme]);
    return (_jsx(QueryClientProvider, { client: queryClientRef.current, children: _jsxs(ThemeProvider, { theme: muiTheme, children: [_jsx(CssBaseline, {}), _jsxs(StoreProvider, { verifiedPhone: verifiedPhone, otpChannels: otpChannels, children: [_jsx(WorkspaceLoader, { onError: onError }), _jsx(WidgetShell, { maxWidth: maxWidth, maxHeight: maxHeight, height: height, calendarOnly: calendarOnly, compact: compact, layout: layout, onError: onError, onSuccess: onSuccess })] })] }) }));
}
